export default __webpack_public_path__ + "static/media/programs-heart.6c36f0ce.png";